<template>
  <div id="index">
    <common-header></common-header>
    <!-- メッセージ -->
      <div v-if="isError" class="errorArea">
        <v-alert
          :value="true"
          type="error"
          outline
        >
          {{errorMessage}}
        </v-alert>
      </div>
      <!-- /メッセージ -->
    <div class="edit-wrapper" v-if="!isLoading">
      <v-layout row>
        <v-flex xs5 md8></v-flex>
        <v-flex xs7 md4>
          <v-switch @click="onStateChange" v-model="release" color="red" :label="`ステータス: ${releaseText.toString()}`"></v-switch>
        </v-flex>
      </v-layout>
      <p class="title" style="margin-top:0px;">
        <v-icon>edit</v-icon>平成年表のタイトル
        <span class="notNull">必須</span>
      </p>
      <v-layout class="title-wrapper" row>
        <v-flex xs9 md10>
          <input @blur="onTitleEdit" class="title-text" type="text" placeholder="タイトルをご記入ください。" v-model="title"/>
        </v-flex>
        <v-flex xs3 md2>
          <p style="font-size:16pt;padding-top:9px;padding-left:5px;">の年表</p>
        </v-flex>
      </v-layout>
      <div v-if="!isTitleInput" style="height:100vh;">
        <p>はじめに年表のタイトルを入力してください</p>
      </div>
      <div v-else>
        <p class="title" style="margin-top:24px;"><v-icon>touch_app</v-icon>年表のタイプを選ぶ</p>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-flex style="max-width:300px;">
          <v-radio-group v-model="editType" row>
            <v-radio color="red" label="自分の年表" value="private"></v-radio>
            <v-radio color="red" label="みんなの年表" value="coEdit"></v-radio>
          </v-radio-group>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <div style="width:95%;max-width:450px;margin:0 auto;border:1px solid #ccc;border-radius:10px;padding:0px 10px;background:#efefef">
          <table style="">
            <tr><td style="padding:5px;border-bottom:1px solid #ccc;width:100px;font-weight:bold">自分の年表</td>
              <td style="padding:7px 0;border-bottom:1px solid #ccc;">自分の想い出の年表です。<br>自分のみが編集できます。</td>
            </tr>
            <tr><td style="font-weight:bold">みんなの年表</td>
              <td style="padding:7px 0;">誰でもできごとを追加できる年表です。<br>できごと以外は作成者しか編集できません。</td></tr>
          </table>
        </div>
        <p class="title"><v-icon>photo</v-icon>トップ（サムネイル）画像</p>
        <input type="file" id="topImage" style="display: none;" ref="topImage" v-on:change="onFileChange" mulitple="multiple">
        <div class="postArea" v-if="uploadedImageForView==undefined">
          <p class="addBtn">
            <v-btn large color="red" dark @click="pickImage('topImage')"><v-icon>add_a_photo</v-icon>&nbsp; 画像を追加する</v-btn>
          </p>
        </div>
        <div v-else style="text-align:center;margin-bottom:16px;">
          <img :src="uploadedImageForView" style="max-width:80%;max-heght:300px;">
          <v-btn fab dark small color="primary" @click="clearImage('topImage')" style="position:relative;right:20px;">
            <v-icon>clear</v-icon>
          </v-btn>
        </div>
        <p class="title" style="margin-top:24px;"><v-icon>edit</v-icon>自由記入欄（トップ）</p>
        <textarea @blur="onIntroductionEdit" placeholder="年表の説明文などご記入ください。
年表ページのトップに表示されます。" rows="5" v-model="introduction" class="message"></textarea>
        <p class="title"><v-icon>edit</v-icon>年表編集
          <span class="select_birthday_wrapper">
            生まれた年：
            <select class="select_birthday" v-model="birthYear">
              <option v-for="(y, id) in years" :key="id" :value="id">
                {{y}}
              </option>
            </select>
          </span>
        </p>
        <div cass="nenpyo">
          <!--年表 Rich-->
          <div v-if="tipsLoading" style="text-align:center;padding:30px;">
            <v-progress-circular class="isLoading" v-show="isLoading" :size="70" :width="7" color="red" indeterminate></v-progress-circular>
          </div>
          <div>
            <v-layout row wrap v-for="(row,id) in tips" :key="id" style="border-top:solid 1px #ddd;padding: 15px 0;">
              <v-flex xs2>
                <div class="nen"><v-chip>{{row.year | displayYear}}</v-chip></div>
                <div style="width:70%;height:90%;border-right:dotted 2px #aaa; margin-top:10px;"></div>
              </v-flex>
              <v-flex xs10>
                <v-card flat>
                  <!-- 共同編集の場合はプロフィール出す -->
                  <v-list-tile v-if="coEdit" avatar>
                    <v-list-tile-avatar size="40" style="z-index:2;" class="coEditProfile">
                      <img :src="row.profileImageUrl">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="row.displayName"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <!-- ／共同編集の場合はプロフィール出す -->
                  <v-img  v-if="row.imageUrl" :src="row.imageUrl" max-height="200px" aspect-ratio="1"></v-img>
                  <v-card-title primary-title>
                    <h3 class="headline" style="width:100%;" v-if="row.title.length>0">{{row.title}}</h3>
                    <div style="width:100%;" v-html="$options.filters.changeBr(row.content)"  v-if="row.content.length>0"></div>
                    <div style="width:100%;" v-if="row.referUrl.length>0"><a :href="row.referUrl" target="_blank">Link：{{row.referUrl}}</a></div>
                  </v-card-title>
                  <v-card-actions v-if="uid === row.uid">
                    <v-btn flat color="red" block @click="onRowEdit(id)"><v-icon>edit</v-icon>編集する</v-btn>
                    <v-btn flat color="red" @click="onRowDelete(id)"><v-icon>close</v-icon>削除する</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <!--／年表 Rich-->
          <div class="postArea" id="addBtn">
            <p class="addBtn">
              <v-btn large color="red" dark @click="dialog=!dialog"><v-icon>add</v-icon>&nbsp; できごとを追加する</v-btn>
            </p>
          </div>
          <p>生まれた年を選択すると、できごと登録が簡単に！</p>
        </div>
        <p class="title" style="margin-top:24px;"><v-icon>edit</v-icon>自由記入欄（文末）</p>
        <textarea @blur="onMessageEdit" placeholder="年表への想いなどご記入ください。
年表ページの文末に表示されます。" rows="5" v-model="message" class="message"></textarea>
        <v-btn block color="red" dark large @click="onSave('top')"><v-icon>send</v-icon>&nbsp;保存して公開する</v-btn>
        <p style="margin-top:16px;"><v-btn v-if="!release" block color="red" outline large @click="onPrivateSave">非公開で保存する</v-btn></p>
        <p v-if="isError" style="text-align:center" class="red--text">エラーがあります。ページトップを確認ください。</p>
      </div>
    </div>
    <v-flex xs12 style="text-align:center;padding-top: 160px;" v-if="isLoading">
      <v-progress-circular class="isLoading" v-show="isLoading" :size="70" :width="7" color="red" indeterminate></v-progress-circular>
    </v-flex>
    <common-footer></common-footer>
    <!-- できごと登録画面 -->
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
      <div v-if="!isLoading" class="edit-wrapper" style="margin: 0 auto">
        <v-card-title flat>
          <span class="headline">できごと追加</span>
          <v-spacer></v-spacer>
          <v-btn flat @click="dialog = false" color="blue"><v-icon>close</v-icon>閉じる</v-btn>
        </v-card-title>
        <!-- メッセージ -->
        <div v-if="tip.isError" class="errorArea">
          <v-alert
            :value="true"
            type="error"
            outline
          >
            {{tip.errorMessage}}
          </v-alert>
        </div>
        <!-- /メッセージ -->
        <v-card-text>
          <p class="title" style="margin-top:0px;">
            年選択
            <span class="notNull">必須</span>
          </p>
          <select class="select-year" v-model="tip.year">
            <option value="">年選択</option>
            <option v-for="(nen, id) in displayNens" :key="id" :value="id">
              {{nen}}
            </option>
          </select>
          <p class="title"><v-icon>photo</v-icon>イメージ画像</p>
          <input type="file" id="tipImage" style="display: none;" ref="tipImage" v-on:change="onFileChange" mulitple="multiple">
          <div class="postArea" v-if="tipUploadedImageForView==undefined">
            <p class="addBtn">
              <v-btn large color="blue" dark @click="pickImage('tipImage')"><v-icon>add_a_photo</v-icon>&nbsp; 画像を追加する</v-btn>
            </p>
          </div>
          <div v-else style="text-align:center;margin-bottom:16px;">
            <img :src="tipUploadedImageForView" style="max-width:80%;max-heght:300px;">
            <v-btn fab dark small color="primary" @click="clearImage('tipImage')" style="position:relative;right:20px;">
              <v-icon>clear</v-icon>
            </v-btn>
          </div>
          <p class="title">
            <v-icon>edit</v-icon>タイトル
            <span class="notNull">必須</span>
          </p>
          <v-layout class="title-wrapper" row>
            <v-flex xs12>
              <input v-model="tip.title" class="title-text" type="text" placeholder="タイトルをご記入ください。"/>
            </v-flex>
          </v-layout>
          <p class="title"><v-icon>edit</v-icon>コメントなど</p>
          <textarea  v-model="tip.content" placeholder="「できごと」への想いなどご記入ください。" rows="3" class="message"></textarea>
          <p class="title" style="margin-top:20px;"><v-icon>edit</v-icon>Youtube、関連記事</p>
          <v-layout class="title-wrapper" row>
            <v-flex xs12>
              <input v-model="tip.referUrl" class="title-text" type="text" placeholder="Youtubeや元記事のURL"/>
            </v-flex>
          </v-layout>
          <p>Youtubeの動画URLを記入すると年表にYoutubeが埋め込めます。</p>
          <v-btn block color="blue" dark large @click="onSave('tip')" style="margin-top:20px;margin-bottom:100px;"><v-icon>send</v-icon>&nbsp;保存する</v-btn>
        </v-card-text>
      </div>
      <v-flex xs12 style="text-align:center;padding-top: 160px;" v-else>
        <v-progress-circular class="isLoading" v-show="isLoading" :size="70" :width="7" color="blue" indeterminate></v-progress-circular>
      </v-flex>
      </v-card>
    </v-dialog>
    <!-- ／できごと登録画面 -->
  </div>
</template>

<script>
import { db } from '../main'
import firebase from 'firebase'
import CommonHeader from './common/CommomHeader'
import CommonFooter from './common/CommomFooter'
import LoginPart from './auth/Login'
var md5 = require('md5')
let fileExtensions = ['jpg', 'jpeg', 'png', 'bmp', 'gif']
let maxWidth = 600
let maxHeight = 600
var FileUploadThumbnail = require('file-upload-thumbnail')
const nens = ['平成元年', '平成2年', '平成3年', '平成4年', '平成5年', '平成6年', '平成7年', '平成8年', '平成9年', '平成10年', '平成11年', '平成12年', '平成13年', '平成14年', '平成15年', '平成16年', '平成17年', '平成18年', '平成19年', '平成20年', '平成21年', '平成22年', '平成23年', '平成24年', '平成25年', '平成26年', '平成27年', '平成28年', '平成29年', '平成30年', '平成31年', '令和元年', '令和2年']
export default {
  name: 'Index',
  data () {
    return {
      mode: 'new',
      uid: '',
      editType: 'private',
      title: '',
      id: '',
      timestamp: undefined,
      message: '',
      introduction: '',
      isLoading: false,
      nens: ['平成元年　（1989年）', '平成2年 　（1990年）', '平成3年 　（1991年）', '平成4年 　（1992年）', '平成5年 　（1993年）', '平成6年 　（1994年）', '平成7年 　（1995年）', '平成8年 　（1996年）', '平成9年 　（1997年）', '平成10年　（1998年）', '平成11年　（1999年）', '平成12年　（2000年）', '平成13年　（2001年）', '平成14年　（2002年）', '平成15年　（2003年）', '平成16年　（2004年）', '平成17年　（2005年）', '平成18年　（2006年）', '平成19年　（2007年）', '平成20年　（2008年）', '平成21年　（2009年）', '平成22年　（2010年）', '平成23年　（2011年）', '平成24年　（2012年）', '平成25年　（2013年）', '平成26年　（2014年）', '平成27年　（2015年）', '平成28年　（2016年）', '平成29年　（2017年）', '平成30年　（2018年）', '平成31年　（2019年4月まで）', '令和元年　（2019年5月～）', '令和2年　（2020年）'],
      isError: false,
      errorMessage: '',
      comment_count: undefined,
      birthYear: '',
      years: [],
      uploadedImageForView: undefined,
      uploadedImage: undefined,
      tipUploadedImageForView: undefined,
      tipUploadedImage: undefined,
      dialog: false,
      tip: {},
      tips: [],
      tipsLoading: false,
      release: false,
      savedData: {},
      imageUploading: false
    }
  },
  computed: {
    coEdit () {
      if (this.editType === 'coEdit') {
        return true
      } else {
        return false
      }
    },
    isLogin () {
      return this.$store.state.view.isLogin
    },
    displayNens () {
      if (this.birthYear === '') {
        return this.nens
      } else {
        let init = 1989
        let birth = Number(this.years[this.birthYear])
        let displayNens = []
        let num = 0
        for (let i = 0; i < this.nens.length; i++) {
          if (this.nens[i] === '令和元年　（2019年5月～）') num--
          let age = init + num - birth
          let text = this.nens[i] + '　' + age + '歳'
          if (age < 0) text = this.nens[i] + '未誕生'
          displayNens.push(text)
          num++
        }
        return displayNens
      }
    },
    isTitleInput () {
      if (this.title.length > 1) {
        return true
      } else {
        return false
      }
    },
    releaseText () {
      if (this.release) {
        return '公開中'
      } else {
        return '非公開'
      }
    }
  },
  mounted () {
    this.tipInit()
    this.uid = firebase.auth().currentUser.uid
    this.mode = this.$route.params.obj.mode
    if (this.mode === 'new') {
      let timestamp = new Date()
      let uid = firebase.auth().currentUser.uid
      this.id = md5(uid + timestamp)
      this.timestamp = timestamp
      this.comment_count = 0
    } else if (this.mode === 'edit') {
      let content = this.$route.params.obj.content
      this.id = this.$route.params.obj.id
      this.tips = this.$route.params.obj.tips
      this.title = content.title
      this.rows = content.rows
      this.message = content.message
      if (content.introduction !== undefined) {
        this.introduction = content.introduction
      } else {
        this.introduction = ''
      }
      this.timestamp = content.timestamp
      this.comment_count = content.comment_count
      if (content.image !== undefined) {
        this.uploadedImageForView = content.imageUrl
        this.uploadedImage = 'saved'
      }
      if (content.coEdit !== undefined) {
        if (content.coEdit) {
          this.editType = 'coEdit'
        } else {
          this.editType = 'private'
        }
      }
      if (content.birthYear !== undefined) {
        this.birthYear = Number(content.birthYear) - 1950
      }
      this.release = content.release
    }
    for (let i = 1950; i <= 2018; i++) {
      this.years.push(i)
    }
  },
  methods: {
    onStateChange () {
      this.save('nonAction')
    },
    onSave (target) {
      if (target === 'top') {
        this.release = true
        this.save()
      } else if (target === 'tip') {
        this.tipSave()
      }
    },
    onPrivateSave () {
      this.save()
    },
    onTitleEdit () {
      if (this.title !== this.savedData.title && this.title.length > 0) {
        this.saveInit()
      }
    },
    onIntroductionEdit () {
      if (this.introduction !== this.savedData.introduction && this.introduction.length > 0) {
        this.saveInit()
      }
    },
    onMessageEdit () {
      if (this.message !== this.savedData.message && this.message.length > 0) {
        this.saveInit()
      }
    },
    saveInit () {
      let timestamp = new Date()
      let saveData = {
        title: this.title,
        message: this.message,
        introduction: this.introduction,
        uid: firebase.auth().currentUser.uid,
        displayName: this.$store.state.view.displayName,
        profileImageUrl: this.$store.state.view.profileImageUrl,
        timestamp: timestamp,
        comment_count: this.comment_count,
        release: this.release,
        type: 'rich',
        coEdit: this.coEdit
      }
      if (this.birthYear !== '') {
        saveData.birthYear = Number(this.birthYear) + 1950
      }
      db.collection('chronology').doc(this.id).set(saveData, {merge: true})
        .then(() => {
          this.savedData = saveData
        })
    },
    save (mode) {
      let timestamp = new Date()
      if (!this.validate()) return
      if (mode === 'nonAction') {
      } else {
        this.isLoading = true
      }
      let saveData = {
        title: this.title,
        message: this.message,
        introduction: this.introduction,
        uid: firebase.auth().currentUser.uid,
        displayName: this.$store.state.view.displayName,
        profileImageUrl: this.$store.state.view.profileImageUrl,
        timestamp: timestamp,
        comment_count: this.comment_count,
        type: 'rich',
        release: this.release,
        coEdit: this.coEdit
      }
      if (this.birthYear !== '') {
        saveData.birthYear = Number(this.birthYear) + 1950
      }
      // image
      if (this.uploadedImage !== undefined) {
        let fname = 'image.png'
        saveData.image = fname
        if (this.uploadedImage !== 'saved') {
          let storageRef = firebase.storage().ref()
          let imageRef = storageRef.child('chronology/' + this.id + '/' + fname)
          imageRef.put(this.uploadedImage).then((snapshot) => {
          })
        }
      }
      db.collection('chronology').doc(this.id).set(saveData, {merge: true})
        .then(function () {
          if (mode === 'nonAction') {
          } else {
            if (this.release) {
              alert('投稿ありがとうございます！！\r\n年表を公開しました。')
            } else {
              alert('投稿ありがとうございます！！\r\n年表を保存しました。\r\n年表を公開してください。')
            }
            this.isLoading = false
            this.$router.push({name: 'Chronology', params: {id: this.id}})
          }
        }.bind(this))
        .catch(function (error) {
          alert('エラーです。申し訳ございません。\r\n再度保存をお願いいたします。')
          console.error(error)
          this.isLoading = false
        }.bind(this))
    },
    getRows (mode) {
      // this.tipsLoading = true
      db.collection('chronology').doc(this.id).collection('tips').orderBy('year', 'asc').orderBy('timestamp', 'asc').get().then((snapshot) => {
        this.tips = []
        snapshot.forEach((doc) => {
          let obj = doc.data()
          obj.id = doc.id
          obj = this.editObj(obj)
          this.tips.push(obj)
        })
        // this.tipsLoading = false
      })
    },
    addRow (obj) {
      obj = this.editObj(obj)
      // リストに存在する場合はアップデート
      let isExist = false
      let position = -1
      for (let i = 0; i < this.tips.length; i++) {
        let t = this.tips[i]
        if (t.id === obj.id) {
          isExist = true
          position = i
          break
        }
      }
      if (isExist) {
        this.tips.splice(position, 1)
      }
      this.tips.push(obj)
      this.tips.sort(function (a, b) {
        if (a.year < b.year) return -1
        if (a.year > b.year) return 1
        return 0
      })
    },
    deleteRow (id) {
      this.tips.splice(id, 1)
    },
    editObj (obj) {
      if (this.imageUploading) return obj
      if (obj.image !== undefined) {
        let fname = `chronology/${this.id}/${obj.image}`
        let encodeFname = encodeURIComponent(fname)
        let imageUrl = `https://firebasestorage.googleapis.com/v0/b/heisei.appspot.com/o/${encodeFname}?alt=media`
        obj.imageUrl = imageUrl
      }
      return obj
    },
    onRowEdit (id) {
      let temp = this.tips[id]
      this.tip = temp
      this.tipUploadedImageForView = this.tip.imageUrl
      this.tipUploadedImage = 'saved'
      this.dialog = true
    },
    tipInit () {
      let y = this.tip.year
      this.tip = {
        year: y,
        title: '',
        content: '',
        referUrl: '',
        uid: '',
        displayName: '',
        profileImageUrl: '',
        timestamp: '',
        isError: false,
        errorMessage: ''
      }
    },
    tipSave () {
      let timestamp = new Date()
      var docId = ''
      if (this.tip.id !== undefined) {
        docId = this.tip.id
      } else {
        docId = md5(this.id + timestamp)
      }
      if (!this.validate_tip()) return
      // this.isLoading = true
      var saveData = {
        year: this.tip.year,
        title: this.tip.title,
        content: this.tip.content,
        referUrl: this.tip.referUrl,
        uid: firebase.auth().currentUser.uid,
        displayName: this.$store.state.view.displayName,
        profileImageUrl: this.$store.state.view.profileImageUrl,
        timestamp: timestamp
      }
      if (this.birthYear !== '') {
        saveData.birthYear = Number(this.birthYear) + 1950
      }
      // image
      if (this.tipUploadedImage !== undefined && this.tipUploadedImage !== 'saved') {
        let fname = md5(docId + timestamp) + '.png'
        saveData.image = fname
        if (this.tipUploadedImage !== 'saved') {
          let storageRef = firebase.storage().ref()
          let imageRef = storageRef.child('chronology/' + this.id + '/' + fname)
          this.imageUploading = true
          imageRef.put(this.tipUploadedImage).then((snapshot) => {
            let obj = saveData
            obj.id = docId
            this.imageUploading = false
            this.addRow(obj)
          })
        }
      } else if (this.tipUploadedImage === 'saved' && this.tip.image !== undefined) {
        saveData.image = this.tip.image
      } else if (this.tipUploadedImage === undefined || this.tip.image === undefined) {
      }
      db.collection('chronology').doc(this.id).collection('tips').doc(docId).set(saveData)
        .then(function () {
          let obj = saveData
          obj.id = docId
          this.addRow(obj)
          if (this.tipUploadedImage !== undefined && this.tipUploadedImage !== 'saved') {
            setTimeout(this.tipSaveFini, 0)
          } else {
            this.tipSaveFini()
          }
        }.bind(this))
        .catch(function (error) {
          alert('エラーです。申し訳ございません。\r\n再度保存をお願いいたします。')
          console.error(error)
          this.isLoading = false
        }.bind(this))
    },
    tipSaveFini () {
      this.clearImage('tipImage')
      alert('できごとを登録しました。')
      this.isLoading = false
      this.dialog = false
      this.tipInit()
      // this.getRows('addRow')
    },
    pickImage (refname) {
      this.$refs[refname].click()
    },
    onFileChange (e) {
      let tagId = e.target.id
      let files = e.target.files || e.dataTransfer.files
      // ファイルのチェック
      // ファイルタイプ
      var myFileType = files[0].type
      var fileTypeCheck = false
      for (var i = 0; i < fileExtensions.length; i++) {
        var fileExtension = fileExtensions[i]
        if (myFileType.indexOf(fileExtension) > -1) {
          fileTypeCheck = true
          break
        }
      }
      if (!fileTypeCheck) {
        if (tagId === 'topImage') {
          this.isError = true
          this.errorMessage = 'アップロードできるファイルは画像のみです。'
        } else {
          this.tip.isError = true
          this.tip.errorMessage = 'アップロードできるファイルは画像のみです。'
        }
        return
      }
      new FileUploadThumbnail({
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        file: files[0],
        onSuccess: function (src) {
          if (tagId === 'topImage') {
            this.uploadedImageForView = src
          } else {
            this.tipUploadedImageForView = src
          }
          // base64 => blob
          let barr, bin, i, len
          bin = atob(src.split('base64,')[1])
          len = bin.length
          barr = new Uint8Array(len)
          i = 0
          while (i < len) {
            barr[i] = bin.charCodeAt(i)
            i++
          }
          let blob = new Blob([barr], {type: 'image/jpeg'})
          if (tagId === 'topImage') {
            this.uploadedImage = blob
          } else {
            this.tipUploadedImage = blob
          }
        }.bind(this)
      }).createThumbnail()
    },
    clearImage (target) {
      if (target === 'topImage') {
        this.uploadedImageForView = undefined
        this.uploadedImage = undefined
      } else {
        this.tipUploadedImageForView = undefined
        this.tipUploadedImage = undefined
      }
    },
    validate () {
      this.isError = false
      this.errorMessage = ''
      if (this.title.length < 1) {
        this.isError = true
        this.errorMessage = 'タイトルは1文字以上入力してください。'
        return false
      }
      if (this.title.length > 100) {
        this.isError = true
        this.errorMessage = 'タイトルは最大100文字までです。'
        return false
      }
      if (this.message > 1000) {
        this.isError = true
        this.errorMessage = '自由記入欄（文末）は最大1000文字です。'
        return false
      }
      if (this.introduction > 1000) {
        this.isError = true
        this.errorMessage = '自由記入欄（トップ）は最大1000文字です。'
        return false
      }
      return true
    },
    validate_tip () {
      this.tip.isError = false
      this.tip.errorMessage = ''
      if (this.tip.year === '') {
        this.tip.isError = true
        this.tip.errorMessage = '年を選択してください。'
        return false
      }
      if (this.tip.title.length < 1) {
        this.tip.isError = true
        this.tip.errorMessage = 'タイトルは1文字以上入力してください。'
        return false
      }
      if (this.tip.title.length > 100) {
        this.tip.isError = true
        this.tip.errorMessage = 'タイトルは最大100文字までです。'
        return false
      }
      if (this.tip.content > 1000) {
        this.tip.isError = true
        this.tip.errorMessage = '自由記入欄は最大1000文字です。'
        return false
      }
      return true
    },
    onRowDelete (id) {
      let target = this.tips[id]
      let text = `「${target.title}」を削除しますか？`
      if (confirm(text)) {
        db.collection('chronology').doc(this.id).collection('tips').doc(target.id).delete().then(function () {
          // this.getRows('deleteRow')
          this.deleteRow(id)
        }.bind(this)).catch(function (error) {
          console.error('Error removing document: ', error)
        })
      }
    }
  },
  filters: {
    changeBr: function (value) {
      return value.toString().replace(/\r?\n/g, '<br>')
    },
    displayYear: function (value) {
      return nens[Number(value)]
    }
  },
  components: {
    CommonHeader,
    CommonFooter,
    LoginPart
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../assets/css/common.css");
ul{
  padding-left: 0 !important;
}
li{
  list-style: none;
}
.edit-wrapper{
  width: 100%;
  max-width: 700px;
  margin: 36px auto;
  padding: 0 10px;
}
.errorArea{
  width: 100%;
  max-width: 700px;
  margin: 0px auto;
}
.postArea{
   background-color:rgba(0,0,1,0.05);
   background-image: url('../assets/image/dot120clear256.png');
   background-repeat:repeat;
   width: 100%;
}
.addBtn{
  padding: 40px 0;
  text-align: center;

}
.nenpyo{
  margin-top: 10px;
}
.v-text-field__details{
  margin-bottom: 0px !important;
}
p.title{
  margin-top: 30px;
  margin-bottom: 5px;
}
.title-wrapper{
  margin-bottom:16px;
}
.title-text{
  border: solid 1px #9f9f9f;
  border-radius: 5px;
  width: 100%;
  height: 50px;
  padding-left: 5px;
  font-size: 110%;
}
.v-input__control{
  margin: 0 auto !important;
}
.select-year{
  border: solid 1px #9f9f9f;
  width: 100%;
  height: 50px;
  border-radius: 5px;
  padding-left: 15px;
  font-size: 110%;
  -webkit-appearance:menulist-button !important;
  -moz-appearance:menulist-button !important;
}
textarea{
  border-bottom: solid 1px #9f9f9f;
  border-top: solid 1px #9f9f9f;
  border-right: solid 1px #9f9f9f;
  width: 100%;
  height: 40px;
  padding-left: 5px;
  font-size: 110%;
}
.close-btn{
  margin-top: 20px;
}
.message{
  border: solid 1px #9f9f9f;
  border-radius: 5px;
  width: 100%;
  height: 100px;
  padding-left: 5px;
  font-size: 110%;
}
.select_birthday{
  border: solid 1px #9f9f9f;
  color: #666;
  background: #fff;
  width: 100px;
  -webkit-appearance:menulist-button !important;
  -moz-appearance:menulist-button !important;
}
.select_birthday_wrapper{
  padding: 5px 10px;
  margin-left: 5px;
  font-size: 11pt;
  color: #fff;
  border-radius: 8px;
  background: #9f9f9f;
  /* border: solid 1px #F44336; */
}
.normal {
  background-color: grey;
}
.dragArea{
  min-height: 10px;
}
.sortable-chosen {
  opacity: 0.7;
  background-color:#fff;
}
.sortable-ghost {
  background-color:#dcdcdc;
}
.nen{
  position: absolute;
  font-weight: bold;
  font-size: 130%;
  z-index: 2;
}
.notNull{
  color:#f44336;
  margin-left: 4px;
  font-size: 90%;
  font-weight: bold;
}
.coEditProfile {
  min-width:45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Edit2.vue